import React from 'react'
import { hashHistory } from 'react-router';
import { useStyle } from "./Style";
import { Grid } from '@mui/material';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import { getPartnerGuid, getUserEmail, getUserFullname } from '../../../lib/access.es6';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import posthog from 'posthog-js';
import { canAccess } from '../../../lib/utils.es6';

const HomePageCta = (props) => {
  const classes = useStyle();

  const handleRegisterCustomer = () => {

    hashHistory.push('admin/generate-policy');
    posthog.capture('clicked_get_a_policy_homepage', {
      email: `${getUserEmail()}`,
      name: `${getUserFullname()}`,
      partner: `${getPartnerGuid()}`,
      timestamp: new Date().toLocaleString(),
    });

  }
  const viewClaims = () => {
    hashHistory.push('admin/claims_dashboard');
  }

  const viewReports = () => {
    hashHistory.push('admin/reports');
  }




  return (
    <>
      <section className={classes.welcomewrapper}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.welcomeheading}>
              <span>
                {props.labels.hello} {getUserFullname()} {props.labels.welcomeBack} !
              </span>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          {canAccess(["REGISTER_CUSTOMER" ]) && (
            <Grid item xs={12} md={3} sm={3}>
              <div className={classes.boxoptionwrapper} onClick={handleRegisterCustomer}>
                <ul>
                  <li><HowToRegOutlinedIcon /></li>
                  <li>Get a policy</li>
                </ul>
              </div>
            </Grid>
          )}

          {canAccess("VIEW_CLAIMS") && (
            <Grid item xs={12} md={3} sm={3}>
              <div className={classes.boxoptionwrapper} onClick={viewClaims}>
                <ul>
                  <li><InventoryOutlinedIcon /></li>
                  <li>{props.labels.viewClaims}</li>
                </ul>
              </div>
            </Grid>
          )}

          {canAccess(["VIEW_BUSINESS_REPORT"]) && (
            <Grid item xs={12} md={3} sm={3}>
              <div className={classes.boxoptionwrapper} onClick={viewReports}>
                <ul>
                  <li><AssignmentIndOutlinedIcon /></li>
                  <li>{props.labels.viewReports}</li>
                </ul>
              </div>
            </Grid>
          )}
        </Grid>
      </section>
      <section className={classes.citybg}></section>
    </>
  )
}

export default HomePageCta